var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSalesActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.97995 27.5C6.37174 27.5 7.5 24.1421 7.5 20H4.97995C3.76546 20 3.15822 20 2.78232 20.4193C2.40641 20.8386 2.47185 21.3908 2.60273 22.4952C2.94823 25.4107 3.88211 27.5 4.97995 27.5Z",
    stroke: "#2177FE",
    strokeWidth: 1.875
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 19.9322V6.69277C7.5 4.80317 7.5 3.85838 8.07744 3.48645C9.02109 2.87866 10.4799 4.15322 11.2136 4.6159C11.8198 4.99822 12.1229 5.18938 12.4593 5.20043C12.8228 5.21236 13.1313 5.02902 13.7864 4.6159L16.175 3.10953C16.8193 2.70319 17.1415 2.5 17.5 2.5C17.8585 2.5 18.1807 2.70319 18.825 3.10953L21.2136 4.6159C21.8198 4.99822 22.1229 5.18938 22.4593 5.20042C22.8229 5.21236 23.1313 5.02902 23.7864 4.6159C24.5201 4.15322 25.9789 2.87866 26.9226 3.48645C27.5 3.85837 27.5 4.80317 27.5 6.69276V19.9322C27.5 23.4997 27.5 25.2834 26.4017 26.3917C25.3033 27.5 23.5355 27.5 20 27.5H5",
    stroke: "#2177FE",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 20C18.8807 20 20 19.1605 20 18.125C20 17.0895 18.8807 16.25 17.5 16.25C16.1193 16.25 15 15.4105 15 14.375C15 13.3395 16.1193 12.5 17.5 12.5M17.5 20C16.4115 20 15.4855 19.4782 15.1423 18.75M17.5 20V21.25M17.5 12.5C18.5885 12.5 19.5145 13.0218 19.8577 13.75M17.5 12.5V11.25",
    stroke: "#2177FE",
    strokeWidth: 1.875,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesActive);
export default __webpack_public_path__ + "static/media/salesActive.8137fb129e98fd6ff900e7b4cd1735d5.svg";
export { ForwardRef as ReactComponent };